module.exports = __webpack_public_path__ + "static/media/profile_bg.4aad2f6f.png";